<div class="d-flex flex-column">
  <label
    class="fw-bold"
    [attr.for]="field().key"
    for="field-type-dropdown"
    translate
    >{{ field().settings?.label }}</label
  >

  <app-boostrap-dropdown
    id="field-type-dropdown"
    [editable]="!formControl?.disabled"
    [items]="items()"
    [currentIndex]="currentIndex"
    styleClass="w-100"
    (selectItem)="setValue($event)"
  >
  </app-boostrap-dropdown>
</div>
